import { Component, effect, ElementRef, HostListener, input, OnInit, signal, viewChild, } from '@angular/core';
import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DeliveryNote, SingleDeliveryNote } from 'api/models';
import { EventsService } from '@app/core/services/event.service';
import { DeliveryNotesService } from 'api/services';
import { lastValueFrom } from 'rxjs';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

@UntilDestroy({
    checkProperties: true,
})
@Component({
    selector: 'app-attachment-counter[deliveryNote]',
    templateUrl: './attachment-counter.component.html',
    styleUrls: ['./attachment-counter.component.scss'],
    imports: [MatTooltip, MatProgressSpinner, TranslateModule],
})
export class AttachmentCounterComponent implements OnInit {
    attachmentLimitInput = input<number>(30, { alias: 'attachmentLimit' });
    deliveryNote = input.required<DeliveryNote>();

    /** Effective attachment limit, seeded from input and overwritten by quota in load(). */
    attachmentLimit = signal<number>(30);

    isLoading = signal(false);
    isVisible: boolean;

    wrapper = viewChild<ElementRef<HTMLDivElement>>('wrapper');

    constructor(
        private sessionService: SessionService,
        private eventsService: EventsService,
        private deliverNotesService: DeliveryNotesService
    ) {
        effect(() => {
            this.attachmentLimit.set(this.attachmentLimitInput());
        });
    }

    @HostListener('window:scroll')
    isInView() {
        const wrapper = this.wrapper();
        if (wrapper) {
            const rect = wrapper.nativeElement.getBoundingClientRect();
            const topShown = rect.top >= 0;
            const bottomShown = rect.bottom <= window.innerHeight;
            this.isVisible = topShown && bottomShown;
        }
    }

    async ngOnInit() {
        await this.load();

        this.eventsService
            .subscribe('attachment-counter:update')
            .pipe(untilDestroyed(this))
            .subscribe(async (deliveryNote: DeliveryNote) => {
                await this.load(deliveryNote);
            });
    }

    async load(deliveryNote?: DeliveryNote) {
        this.isInView();
        /*        if (deliveryNote) {
            this.deliveryNote = deliveryNote;
        }
        if (!this.isVisible) {
            return;
        }*/
        this.isLoading.set(true);
        try {
            const quotas = await this.sessionService.getQuotas();
            this.attachmentLimit.set(
                quotas?.maxQuotas?.maxDeliveryNoteAttachments || 30
            );

            if (deliveryNote) {
                if (
                    this.deliveryNote() &&
                    deliveryNote._key === this.deliveryNote()._key
                ) {
                    // only reload delivery note if global event delivery note is the same as this class field's delivery note
                    const deliveryNote: SingleDeliveryNote =
                        await lastValueFrom(
                            this.deliverNotesService.getSingleDeliveryNoteMetaData(
                                {
                                    deliveryNoteKey: this.deliveryNote()._key,
                                }
                            )
                        );
                    this.deliveryNote().attachmentsCount =
                        deliveryNote.attachmentsCount;
                }
            } else {
                const deliveryNote: SingleDeliveryNote = await lastValueFrom(
                    this.deliverNotesService.getSingleDeliveryNoteMetaData({
                        deliveryNoteKey: this.deliveryNote()._key,
                    })
                );
                this.deliveryNote().attachmentsCount =
                    deliveryNote.attachmentsCount;
            }
        } catch (error) {}
        this.isLoading.set(false);
    }
}
